import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import i18next from "i18next";
import CustomCheckbox from "../../pages/Singin/components/CustomCheckbox";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const AgeCheckModal = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const location = useLocation();

  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  // 處理確認按鈕
  const handleConfirm = () => {
    // 設sessionStorage表示點擊過"已滿18歲"按鈕
    sessionStorage.setItem("age-verified", "true");

    if (isChecked) {
      // 如果勾選了 不再顯示
      const expiryDate = dayjs().add(3, "day"); //三天後會過期

      localStorage.setItem(
        "age-verification-expiry-date",
        JSON.stringify({ expiry: expiryDate })
      ); // 存到 localStorage
    }
    setShowModal(false);
  };

  const toggleCheck = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    // 檢查當前路徑是否包含 create-machine
    if (location.pathname.includes("create-machine")) {
      setShowModal(false);
      return; // 如果是 create-machine 頁面，直接返回，不執行後面的邏輯
    }

    // 先檢查sessionStorage
    const sessionVerified = sessionStorage.getItem("age-verified");
    if (sessionVerified === "true") {
      setShowModal(false);
      return;
    }
    //如果sessionStorage沒有標記 繼續檢查localStorage

    //取得local的年齡過期日期，如果沒有存在的話代表沒按過，預設值給予他null
    const verification_expiry_date =
      localStorage.getItem("age-verification-expiry-date") || null;
    const pare_verification_expiry_date = verification_expiry_date
      ? JSON.parse(verification_expiry_date)
      : null;

    //將格式轉為 YYYY-MM-DD HH:mm:ss  ex:2022-09-01 00:00:00
    const fmt_verification_expiry_date = pare_verification_expiry_date
      ? dayjs(pare_verification_expiry_date).format("YYYY-MM-DD HH:mm:ss")
      : null;
    const fmt_current_time = dayjs().format("YYYY-MM-DD HH:mm:ss");

    //判斷當前日期是否超過過期日期
    const current_date_is_over_expiry_date = fmt_verification_expiry_date
      ? fmt_verification_expiry_date < fmt_current_time
      : false;

    if (!verification_expiry_date) {
      //Null就顯示Age Modal
      setShowModal(true);
    } else {
      if (current_date_is_over_expiry_date) {
        //過期就顯示Age Modal
        setShowModal(true);
      } else {
        //沒過期就不顯示Age Modal
        setShowModal(false);
      }
    }
  }, [location.pathname]); // 路徑改變時重新執行

  return (
    showModal && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="1000000"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <ChakraBox
          as={Flex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="420px"
          minH="300px"
          bgImage={`url('${COMMON_WEB_PATH}/now888/modal/hintBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          position={"relative"}
          p={6}
          pt={"50px"}
        >
          <AbsoluteCenter
            display="flex"
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
            top="-30px"
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/modal/hintWORD${
                i18next.language == "tw" ? "" : `_${i18next.language}`
              }.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </AbsoluteCenter>
          {/* 隱形XX */}
          <Box
            position="absolute"
            top="0"
            right="0"
            w="60px"
            h="30px"
            onClick={handleConfirm}
            cursor="pointer"
          ></Box>
          <Box>
            <Image />
          </Box>
          <Box
            fontSize={{ base: "24px", lg: "28px", xl: "28px" }}
            color="white"
            textAlign="center"
            mb={1}
            minH="200px"
            overflow="scroll"
            display="flex"
            alignItems={"center"}
          >
            <Text color="#FFF" fontWeight="700">
              {i18n("18Age")}
            </Text>
          </Box>

          <Flex gap={4} my={6} justifyContent="center" alignItems="center">
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${COMMON_WEB_PATH}/now888/button/confirm_background.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
              _hover={{
                // filter: isChecked ? "brightness(1.1)" : "grayscale(100%)",
                filter: "brightness(1.1)",
              }}
            >
              <Image
                src={`${COMMON_WEB_PATH}/now888/18age${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/18age_confirm_button.png`}
                width={{
                  base: "70%",
                  xl: "70%",
                }}
              />
            </Flex>
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${COMMON_WEB_PATH}/now888/button/cancel_background.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              _hover={{ filter: "brightness(1.1)" }}
              onClick={() => {
                navigate(-1);
              }}
            >
              <Image
                src={`${COMMON_WEB_PATH}/now888/18age${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/18age_cancel_button.png`}
                width={{
                  base: "70%",
                  xl: "70%",
                }}
              />
            </Flex>
          </Flex>
          <CustomCheckbox
            isChecked={isChecked}
            onChange={toggleCheck}
            labelText={i18n("noShow")}
          />
        </ChakraBox>
      </Flex>
    )
  );
};

export default AgeCheckModal;
